import script from "./EditSignal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditSignal.vue?vue&type=script&setup=true&lang=js"

import "./EditSignal.vue?vue&type=style&index=0&id=36629682&lang=scss"

const __exports__ = script;

export default __exports__